var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/MainConnection/index.tsx";
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { LoadingSpinner, Stack } from '@adc/parallax-component-library';
import { useApiError, useConnection } from 'Hooks';
import { LogoActionBar, Main, ScrollContainer } from 'Components/utility';
import { InAppActionBar } from 'Components/utility/ActionBar/InAppActionBar';
import { ANALYTICS_ACTIONS, ANALYTICS_EVENTS, ANALYTICS_MODULE_TYPES } from 'Constants/analytics';
import { CONNECTIONS } from 'Reducers/connections/types';
import * as analyticsManager from 'Utilities/analytics/analyticsManager';
import { notifyApp } from 'Utilities/appCommunicator';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import ConnectionCardsList from './ConnectionCardsList';
const mapStateToProps = ({
  env: {
    app
  }
}) => {
  return {
    isLibre: app === 'libre1'
  };
};
const connector = connect(mapStateToProps);
const MainConnection = ({
  isLibre
}) => {
  const {
    getConnections
  } = useConnection();
  const {
    showApiErrorModal
  } = useApiError();
  const [loading, setLoading] = useState(true);
  const [connections, setConnections] = useState();
  useEffect(() => {
    const loadConnections = async () => {
      try {
        setLoading(true);
        const connections = await getConnections();
        const conn = connections.partnerConnections?.reduce((acc, curr) => {
          if (curr.consent.needsMigration) {
            acc[0].push({
              partner: curr.partner,
              invitation: curr.consent
            });
          } else {
            acc[1].push(curr);
          }
          return acc;
        }, [[], []]);
        connections.partnerInvitations = [...(conn?.[0] ?? []), ...(connections.partnerInvitations ?? [])];
        connections.partnerConnections = [...(conn?.[1] ?? [])];
        store.dispatch({
          type: CONNECTIONS,
          connections
        });
        setConnections(connections);
      } catch {
        showApiErrorModal();
      } finally {
        setLoading(false);
      }
    };
    loadConnections();
  }, [getConnections, showApiErrorModal]);
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 5
    }
  }, isLibre ? /*#__PURE__*/React.createElement(InAppActionBar, {
    onBack: () => {
      analyticsManager.track(ANALYTICS_EVENTS.CONNECTION_MANAGED, {
        module: ANALYTICS_MODULE_TYPES.CONAPPS_MODULE,
        action: ANALYTICS_ACTIONS.ABANDON
      });
      notifyApp('adc-webview:navigate-back-app');
    },
    closeBtn: true,
    title: i18n.t('Connections.title'),
    testID: "Connections",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 9
    }
  }) : /*#__PURE__*/React.createElement(LogoActionBar, {
    testID: "Connections",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 9
    }
  }), loading ? /*#__PURE__*/React.createElement(Stack, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(LoadingSpinner, {
    testID: "LibreLinkUp.spinner",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 11
    }
  })) : /*#__PURE__*/React.createElement(ScrollContainer, {
    marginTop: isLibre ? 0 : 115,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(ConnectionCardsList, {
    connections: connections,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 11
    }
  })));
};
export default connector(MainConnection);